export default __webpack_public_path__ + "static/media/dna_bg.8afe74d7.png";